import { FaCheckCircle, FaArrowRight } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import SEO from '../../lib/SEO'
import styles from './about.module.scss'

import driverImg from '../../assets/img/trucks/truck3.jpg'
import flatbedImg from '../../assets/img/trucks/truck1.jpg'

const About = () => (
  <>
    <SEO
      title='About Vision International – Trusted American Carrier Since 2015'
      description='Vision International LLC is a Chicago-based trucking company with 15+ years of experience. Nationwide coverage across 48 states. Learn our story.'
      keywords='Vision International about, Chicago trucking company, American freight carrier'
      canonical='https://vi4u.net/about-us'
    />

    <div className={styles.page}>
      {/* HERO */}
      <div className={styles.hero}>
        <div className={styles.heroText}>
          <span className={styles.label}>About Us</span>
          <h1>
            <span>Chicago-born.</span>
            <span className={styles.yellow}>Nationwide.</span>
          </h1>
          <p>
            Founded in 2015 on the South Side of Chicago, Vision International grew from a small
            fleet to a nationwide operation — built on one principle: be the most dependable carrier
            your customers ever work with.
          </p>
        </div>
        <div className={styles.heroPhoto}>
          <img
            src={flatbedImg}
            alt='Vision International flatbed truck on highway'
          />
        </div>
      </div>

      {/* STORY */}
      <div className={styles.story}>
        <div className={styles.storyInner}>
          <div className={styles.storyText}>
            <span className={styles.label}>Our Story</span>
            <h2>
              Built from the
              <br />
              <span className={styles.yellow}>ground up.</span>
            </h2>
            <p>
              Vision International was founded by Robert Matracki, who started his career behind
              the wheel as a truck driver. Years on the road gave him a deep understanding of what
              this industry demands — and the conviction to build a company that does it right.
            </p>
            <p>
              Fifteen years later, we run dedicated lanes across the Midwest, Southeast, and East
              Coast. We added refrigerated units, flatbed equipment, and specialized cargo
              capability. But the fundamentals have never changed.
            </p>
            <p>
              Vision International is family-owned, FMCSA-certified, and proud to be 100%
              American-operated.
            </p>
          </div>
          <div className={styles.storyStats}>
            {[
              { n: '2015', l: 'Founded, Chicago IL' },
              { n: '24/7', l: 'Dispatch Available' },
              { n: '450+', l: 'CDL-A Drivers' },
              { n: '48', l: 'States Covered' },
            ].map((s) => (
              <div
                key={s.l}
                className={styles.storyStat}
              >
                <span className={styles.statN}>{s.n}</span>
                <span className={styles.statL}>{s.l}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* DRIVER PHOTO SECTION */}
      <div className={styles.driverSection}>
        <div className={styles.driverPhoto}>
          <img
            src={driverImg}
            alt='Professional Vision International driver'
          />
        </div>
        <div className={styles.driverText}>
          <span className={styles.label}>Our People</span>
          <h2>
            Drivers you <span className={styles.yellow}>can trust.</span>
          </h2>
          <p>
            Our 450+ CDL-A drivers are the backbone of Vision International. Every driver undergoes
            rigorous screening, regular training, and drug testing. Clean MVRs, ELD compliance, and
            a safety-first mindset on every run.
          </p>
          <ul className={styles.driverList}>
            <li>
              <FaCheckCircle /> CDL-A Licensed, clean MVR
            </li>
            <li>
              <FaCheckCircle /> Drug & background screened
            </li>
            <li>
              <FaCheckCircle /> ELD & FMCSA compliant
            </li>
            <li>
              <FaCheckCircle /> Experienced long-haul professionals
            </li>
          </ul>
        </div>
      </div>

      {/* COMPLIANCE */}
      <div className={styles.compliance}>
        <div className={styles.complianceInner}>
          <span className={styles.label}>Credentials</span>
          <h2>
            Licensed, Certified <span className={styles.yellow}>&amp; Compliant.</span>
          </h2>
          <div className={styles.complianceGrid}>
            {[
              'DOT # 1312675',
              'MC# 550806',
              'FMCSA Safety: Satisfactory',
              'CTPAT Certified Partners',
              'ELD Compliant Fleet',
              'HAZMAT Certified Drivers',
              'FSMA Compliant Reefers',
              'SmartWay Transport Partner',
            ].map((item) => (
              <div
                key={item}
                className={styles.compItem}
              >
                <FaCheckCircle className={styles.check} />
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className={styles.cta}>
        <h2>Ship with Vision International.</h2>
        <p>Join thousands of shippers who trust us with their freight every day.</p>
        <Link
          to='/contact-us'
          className={styles.ctaBtn}
        >
          Get a Free Quote <FaArrowRight />
        </Link>
      </div>
    </div>
  </>
)

export default About
